import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("ci-theme");
    return saved === null ? true : saved !== "light";
  });

  useEffect(() => {
    if (isDark) {
      document.body.classList.remove("light-theme");
      localStorage.setItem("ci-theme", "dark");
    } else {
      document.body.classList.add("light-theme");
      localStorage.setItem("ci-theme", "light");
    }
  }, [isDark]);

  const toggle = () => setIsDark(prev => !prev);

  return (
    <ThemeContext.Provider value={{ isDark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
